<template lang="pug">
  transition(name="root-fade")
    #app(@mousemove="onMouseMove" v-show="isLoaded")
      Header(:screenSize="screenSize")
      ThreejsScene(:mouse="mouse" :screenSize="screenSize")
      .page-wrapper(:class="{ 'lock': isLock }")
        transition(:name="transitionName" @after-leave="scrollTop")
          router-view(:screenSize="screenSize")
</template>

<script>
import Header from './components/Header'
import ThreejsScene from './components/ThreejsScene'

export default {
  components: { Header, ThreejsScene },
  name: 'App',
  data () {
    return {
      isLoaded: false,
      transitionName: "section-fade",
      mouse: {x:0,y:0},
      screenSize: {width: 0, height: 0}
    }
  },
  computed: {
    isLock: function(){
      return this.$route.path.split('/').length > 2;
    }
  },
  methods: {
    onMouseMove: function ( e ) {
      this.mouse.x = e.clientX - window.innerWidth/2;
      this.mouse.y = e.clientY - window.innerHeight/2;
      if(this.screenSize.width < 800) {
        this.mouse.x = 0;
        this.mouse.y = 0;
      }
    },
    scrollTop() {
      document.getElementsByClassName('page-wrapper')[0].scrollTo(0,0);
    },
    // onClick: function() {
    //   console.log("!");

    //   this.$fullscreen.enter(document.body,{
    //     wrap: false,
    //   })
    // }
  },
  mounted() {

    this.isLoaded = true;
    this.screenSize.width = window.innerWidth;
    this.screenSize.height = window.innerHeight;
    window.onresize = () => {
      this.screenSize.width = window.innerWidth;
      this.screenSize.height = window.innerHeight;
    };
  },
  watch: {
    '$route' (to, from) {

      // console.log(to.path.split('/'));
      if(to.path === "/" || from.path === "/") {
        this.transitionName = "landing-fade"
      }

      else if(to.path.indexOf("works") != -1 && to.path.split('/').length > 2) {
        this.transitionName = "work-detail";
      }

      else {
        this.transitionName = "section-fade";
      }
    }
  }
}
</script>


<style lang="sass">
  $breakpoint: 1000px

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video
    margin: 0
    padding: 0
    border: 0
    font-size: 100%
    font: inherit
    vertical-align: baseline
    text-decoration: none

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section
    display: block

  body
    line-height: 1

  ol, ul
    list-style: none

  blockquote, q
    quotes: none

  blockquote:before, blockquote:after,
  q:before, q:after
    content: ''
    content: none

  table
    border-collapse: collapse
    border-spacing: 0

  a
    color: #fff
    text-decoration: underline

  *
    box-sizing: border-box
    position: relative
    outline: none
    // user-select: none
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0)

  @import url('https://fonts.googleapis.com/css?family=Noto+Serif+TC')

  html,body
    width: 100%
    // min-height: 100%
    height: 100%
    background-color: #000
    // font-family: PingFangTC, "微軟正黑體", sans-serif
    font-family: letter-gothic-std, 'Noto Serif TC', sans-serif
    font-weight: 400
    color: #fff
    font-style: normal
    // font-weight: normal
    // line-height: normal
    overflow: hidden
    letter-spacing: 1px
    ::selection
      background: #fff
      color: #000

  #app
    display: flex
    flex-direction: column
    align-items: center
    // margin-top: 60px
    height: 100%

  .page-wrapper
    width: 100%
    height: 100%
    // min-height: 100%
    // max-width: 1600px
    // @media screen and (max-width: 350px)
    padding: 0 20px
    display: flex
    flex-direction: column
    align-items: center
    overflow: scroll
    overflow-x: hidden
    &.lock
      overflow: hidden
    >section
      width: 100%
      // min-height: 100vh
      display: flex
      flex-direction: column
      // &.active
        // display: flex

  .section-title
    font-size: 60px
    text-transform: uppercase

  .root-fade-enter-active, .root-fade-leave-active
    transition-property: opacity
    transition-duration: 1.5s
  .root-fade-enter-active
    transition-delay: 1.5s
  .root-fade-enter, .root-fade-leave-active
    opacity: 0




  .fade-enter-active, .fade-leave-active
    transition-property: opacity
    transition-duration: .5s
  .fade-enter-active
    transition-delay: .5s
  .fade-enter, .fade-leave-active
    opacity: 0


  .section-fade-enter-active, .section-fade-leave-active
    transition-property: opacity, transform
    transition-duration: 1s
  .section-fade-enter-active
    transition-delay: 1s
  .section-fade-enter, .section-fade-leave-active
    opacity: 0
    transform: translateX(-30px)

  .landing-fade-enter-active, .landing-fade-leave-active
    transition-property: opacity, transform
    transition-duration: 1s
  .landing-fade-enter-active
    transition-delay: 1s
  .landing-fade-enter, .landing-fade-leave-active
    opacity: 0


  // .work-detail-enter-active, .work-detail-leave-active
  //   transition-property: opacity, transform
  //   transition-duration: 1s
  // .work-detail-enter-active
  //   transition-delay: 1s
  // .work-detail-enter, .work-detail-leave-active
  //   opacity: 0

</style>



// WEBPACK FOOTER //
// src/App.vue